var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeavyFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 31,
    viewBox: "0 0 37 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9578 15.3109C22.2041 15.9495 23.5982 16.6639 25.411 16.6639C28.863 16.6639 34.2329 12.42 35 8.17605C33.9772 8.56186 31.4712 9.33348 29.6301 9.33348C27.789 9.33348 25.0274 7.01862 25.0274 7.01862C25.0274 7.01862 21.6521 2.38892 17.3562 2.38892C13.0603 2.38892 11.4749 4.18936 11.2192 5.08958V17.4355C13.58 15.3483 14.9816 14.6819 17.7397 14.349C18.8248 14.218 19.8308 14.7335 20.9578 15.3109ZM7 25.9421C7.96921 27.3265 9.13327 28.563 10.4521 29.6111V5.2824C10.4521 4.32355 9.67929 3.54625 8.72603 3.54625C7.77277 3.54625 7 4.32355 7 5.2824V25.9421Z",
    fill: "#C1C5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeavyFlagIcon);
export default __webpack_public_path__ + "static/media/weavy-flag-icon.0d06daf6205ef3625a00e1c2e7d89d2b.svg";
export { ForwardRef as ReactComponent };